import React, { useState, useEffect } from 'react';
import './About.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import contactService from '../api/contactService'; // Path to your service
import { Link } from 'react-router-dom';

const Contact = () => {
  useEffect(() => {
    // Force window to scroll to the very top instantly when the component mounts
    window.scrollTo(0, 0);
    AOS.init({ duration: 1000, once: true });
  }, []);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    services: "",
    message: ""
  });
  
  const [status, setStatus] = useState({ type: "", msg: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: "info", msg: "Sending..." });

    try {
      // Ensure phoneNumber is sent as a number if your backend requires it
      const payload = {
        ...formData,
        phoneNumber: formData.phoneNumber.replace(/\D/g, '') // Removes non-digits
      };

      const response = await contactService.createContact(payload);

      // Check if response exists and indicates success
      if (response && response.success) {
        setStatus({ type: "success", msg: "Message sent successfully!" });
        setFormData({ name: "", email: "", phoneNumber: "", services: "", message: "" });
      } else {
        // Handle case where success is false but no error was thrown
        setStatus({ type: "danger", msg: response.message || "Failed to send message." });
      }
    } catch (error) {
      console.error("Submission error:", error);
      // Capture the specific validation error from your backend response
      const serverError = error.response?.data?.error || error.response?.data?.message;
      setStatus({ 
        type: "danger", 
        msg: serverError || "Failed to send message. Please try again." 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="services-page">
      {/* HERO SECTION */}
      <section className="services-hero-container">
        <div className="hero-overlay">
          <div className="container text-center">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-center">
                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                <li className="breadcrumb-item active text-white" aria-current="page">Contact Us</li>
              </ol>
            </nav>
            <h1 className="display-3 fw-bold text-white">Contact Us</h1>
            <div className="yellow-divider mx-auto my-3"></div>
            <p className="lead text-light mt-3 mx-auto" style={{ maxWidth: '800px' }}>
              Construction is the process of planning, designing, and building infrastructure.
            </p>
          </div>
        </div>
      </section>
      
      {/* CONTACT SECTION */}
      <section className="contact-section py-5">
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-8">
              <div className="contact-form-card p-5 bg-white shadow-sm">
                <h6 className="text-uppercase text-muted fw-bold small">Start Your Journey Today</h6>
                <h2 className="display-5 fw-bold mb-4">Let's Talk Together</h2>
                
                {/* STATUS MESSAGE */}
                {status.msg && (
                  <div className={`alert alert-${status.type} alert-dismissible fade show`} role="alert">
                    {status.msg}
                    <button type="button" className="btn-close" onClick={() => setStatus({type:"", msg:""})}></button>
                  </div>
                )}

                <form className="row g-3" onSubmit={handleSubmit}>
                  <div className="col-md-6">
                    <input 
                      type="text" 
                      name="name"
                      className="form-control" 
                      placeholder="Full Name*" 
                      value={formData.name}
                      onChange={handleChange}
                      required 
                    />
                  </div>
                  <div className="col-md-6">
                    <input 
                      type="email" 
                      name="email"
                      className="form-control" 
                      placeholder="Email Address*" 
                      value={formData.email}
                      onChange={handleChange}
                      required 
                    />
                  </div>
                  <div className="col-md-6">
                    <input 
                      type="tel" 
                      name="phoneNumber"
                      className="form-control" 
                      placeholder="Phone Number*" 
                      value={formData.phoneNumber}
                      onChange={handleChange}
                      required 
                    />
                  </div>
                  <div className="col-md-6">
                    <input 
                      type="text" 
                      name="services"
                      className="form-control" 
                      placeholder="Your Services*" 
                      value={formData.services}
                      onChange={handleChange}
                      required 
                    />
                  </div>
                  <div className="col-12">
                    <textarea 
                      name="message"
                      className="form-control" 
                      rows="4" 
                      placeholder="Message*"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>
                  <div className="col-12">
                    <button type="submit" className="btn btn-dark px-5 py-3" disabled={loading}>
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Processing...
                        </>
                      ) : (
                        <>Submit Request <i className="bi bi-arrow-up-right"></i></>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
            
            <div className="col-lg-4">
               {/* Information boxes remain unchanged */}
               <div className="contact-info-list h-100">
                <div className="info-box d-flex align-items-center p-4 mb-3 bg-white shadow-sm rounded-3">
                  <div className="icon-wrap bg-dark text-warning p-3 rounded-3 me-3">
                    <i className="bi bi-envelope-open"></i>
                  </div>
                  <div>
                    <h5 className="mb-0 fw-bold">Email Support</h5>
                    <p className="mb-0 text-muted">vpsinfrastructures@gmail.com</p>
                  </div>
                </div>

                    <div className="info-box d-flex align-items-center p-4 mb-3 bg-white shadow-sm rounded-3">
                      <div className="icon-wrap bg-dark text-warning p-3 rounded-3 me-3">
                        <i className="bi bi-telephone-outbound"></i>
                      </div>
                      <div>
                        <h5 className="mb-0 fw-bold">Call Our Office</h5>
                        <p className="mb-0 text-muted">+91 7010342038</p>
                      </div>
                    </div>

                    <div className="info-box d-flex align-items-center p-4 mb-3 bg-white shadow-sm rounded-3">
                      <div className="icon-wrap bg-dark text-warning p-3 rounded-3 me-3">
                        <i className="bi bi-geo-alt"></i>
                      </div>
                      <div>
                        <h5 className="mb-0 fw-bold">Visit Our Office</h5>
                        <p className="mb-0 text-muted">26/B6,Indra Nagar,Vedasandur Dindigul – 624710</p>
                      </div>
                    </div>

                    <div className="info-box d-flex align-items-center p-4 mb-3 bg-white shadow-sm rounded-3">
                      <div className="icon-wrap bg-dark text-warning p-3 rounded-3 me-3">
                        <i className="bi bi-whatsapp"></i>
                      </div>
                      <div>
                        <h5 className="mb-0 fw-bold">WhatsApp Support</h5>
                        <p className="mb-0 text-muted">+91 7010342038</p>
                      </div>
                    </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;